var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1201 9.62012H12.8701C12.4601 9.62012 12.1201 9.28012 12.1201 8.87012C12.1201 8.46012 12.4601 8.12012 12.8701 8.12012H18.1201C18.5301 8.12012 18.8701 8.46012 18.8701 8.87012C18.8701 9.28012 18.5401 9.62012 18.1201 9.62012Z",
    fill: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62006 10.3803C7.43006 10.3803 7.24006 10.3103 7.09006 10.1603L6.34006 9.41031C6.05006 9.12031 6.05006 8.64031 6.34006 8.35031C6.63006 8.06031 7.11006 8.06031 7.40006 8.35031L7.62006 8.57031L9.34006 6.85031C9.63006 6.56031 10.1101 6.56031 10.4001 6.85031C10.6901 7.14031 10.6901 7.62031 10.4001 7.91031L8.15006 10.1603C8.01006 10.3003 7.82006 10.3803 7.62006 10.3803Z",
    fill: "#212529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1201 16.6201H12.8701C12.4601 16.6201 12.1201 16.2801 12.1201 15.8701C12.1201 15.4601 12.4601 15.1201 12.8701 15.1201H18.1201C18.5301 15.1201 18.8701 15.4601 18.8701 15.8701C18.8701 16.2801 18.5401 16.6201 18.1201 16.6201Z",
    fill: "#212529"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62006 17.3803C7.43006 17.3803 7.24006 17.3103 7.09006 17.1603L6.34006 16.4103C6.05006 16.1203 6.05006 15.6403 6.34006 15.3503C6.63006 15.0603 7.11006 15.0603 7.40006 15.3503L7.62006 15.5703L9.34006 13.8503C9.63006 13.5603 10.1101 13.5603 10.4001 13.8503C10.6901 14.1403 10.6901 14.6203 10.4001 14.9103L8.15006 17.1603C8.01006 17.3003 7.82006 17.3803 7.62006 17.3803Z",
    fill: "#212529"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22.75H9.5C4.07 22.75 1.75 20.43 1.75 15V9C1.75 3.57 4.07 1.25 9.5 1.25H15.5C20.93 1.25 23.25 3.57 23.25 9V15C23.25 20.43 20.93 22.75 15.5 22.75ZM9.5 2.75C4.89 2.75 3.25 4.39 3.25 9V15C3.25 19.61 4.89 21.25 9.5 21.25H15.5C20.11 21.25 21.75 19.61 21.75 15V9C21.75 4.39 20.11 2.75 15.5 2.75H9.5Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.10f803442ebc39aa14f2686fb67ca6d0.svg";
export { ForwardRef as ReactComponent };